import styles from './index.module.scss';
import { utility } from '@phi/components';
import { defineComponent, h, PropType } from 'vue';
import { random_id } from '@phi/util';

export const FormRange = defineComponent({
    props: {
        min: {
            required: false,
            type: Number,
            default: 0,
        },

        max: {
            required: false,
            type: Number,
            default: 100,
        },

        step: {
            required: false,
            type: Number,
            default: 1,
        },

        value: {
            required: true,
            type: Number,
        },

        label: {
            required: false,
            type: String,
        },

        labels: {
            required: false,
            type: Array as PropType<Array<{ value: number; label: string }>>,
        },

        percentage: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onChange(e: InputEvent) {
            return this.$emit('update:value', parseFloat((e.target as HTMLInputElement).value));
        },

        output_indicator(x: number): string {
            if (this.percentage) {
                const value = Math.floor(100 * (this.value - this.min) / (this.max - this.min));
                switch (value) {
                    case 0: return 'Min';
                    case 100: return 'Max';
                    default: return value + '%';
                }
            } else
                return x.toString();
        }
    },

    emits: {
        'update:value': (x: number) => true,
    },

    data() {
        return {
            id: random_id(),
            dl_id: random_id(),
        };
    },

    render() {
        const output = h('output', {
            class: [
                utility.block,
                utility.w_100,
                utility.right,
                utility.small,
                styles.output,
            ]
        }, this.output_indicator(this.value));

        const input = h('input', {
            type: 'range',
            id: this.id,
            list: this.dl_id,
            value: this.value,
            onInput: this.onChange,
            min: this.min,
            max: this.max,
            step: this.step,
            class: utility.w_100,
        });

        const labels =  h(
            'div',
            { class: [utility.flex, utility.space_between] },
            this.labels && this.labels.map(x => h('div', {
                as: 'div',
                class: [styles.option, utility.small, utility.no_interact],
            }, x.label)),
        );


        const dl = h(
            'datalist',
            { id: this.dl_id },
            this.labels && this.labels.map(x => h('option', {
                label: x.label,
                value: x.value,
                as: 'option',
            })),
        );

        if (this.label)
            return h('label', { class: [ 'form-range', styles.range ] }, [
                h('span', { class: 'label-text' }, this.label),
                output,
                input,
                labels,
                dl,
            ]);
        else
            return h('div', { class: [ 'form-range', styles.range ] }, [
                output,
                input,
                labels,
                dl,
            ]);
    },
});
